<div class="modal inmodal fade in parcel-modal parcel-history-modal show">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Quick Parcel Search</h4>
            </div>
            <div class="modal-body display-flex">
                <input class="form-control" [(ngModel)]="parcelBarcode" (keydown.enter)="getParcelByBarcode()" required>
                <button type="button" class="btn btn-primary" (click)="getParcelByBarcode()">Scan Barcode</button>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/parcels/enter-parcel-barcode-modal/enter-parcel-barcode-modal.component.html